var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconDetail3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    transform: "translate(0 0.499756)",
    fill: "white",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5625 16.3123H4.125V17.6873H7.5625V16.3123Z",
    fill: "#3A3B3C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5625 13.5623H4.125V14.9373H7.5625V13.5623Z",
    fill: "#3A3B3C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9375 21.1248H2.75C1.99375 21.1248 1.375 20.506 1.375 19.7498V12.1873C1.375 11.431 1.99375 10.8123 2.75 10.8123H8.9375C9.69375 10.8123 10.3125 11.431 10.3125 12.1873V19.7498C10.3125 20.506 9.69375 21.1248 8.9375 21.1248ZM2.75 12.1873V19.7498H8.9375V12.1873H2.75Z",
    fill: "#3A3B3C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5625 1.87476H13.0625V3.24976H18.5625V1.87476Z",
    fill: "#3A3B3C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.625 4.62476H15.125V5.99976H20.625V4.62476Z",
    fill: "#3A3B3C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.625 7.37476H15.125V8.74976H20.625V7.37476Z",
    fill: "#3A3B3C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5625 10.1248H13.0625V11.4998H18.5625V10.1248Z",
    fill: "#3A3B3C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.625 12.8748H15.125V14.2498H20.625V12.8748Z",
    fill: "#3A3B3C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 1.18726L7.2875 2.14976L9.075 3.93726H2.75C1.99375 3.93726 1.375 4.55601 1.375 5.31226V8.74976H2.75V5.31226H9.075L7.2875 7.09976L8.25 8.06226L11.6875 4.62476L8.25 1.18726Z",
    fill: "#3A3B3C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDetail3);
export default __webpack_public_path__ + "static/media/iconDetail3.9b20b7fb6e939a21c00c9af7872285a8.svg";
export { ForwardRef as ReactComponent };